import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";
import { useParams } from "react-router-dom";

const OfferDetail = inject("mainStore")(
    observer(({ mainStore, setStep, step }) => {
        const { secondParam } = useParams();

        let inputsNew = [
            {
                blockName: "Вендор",
                inputs: {
                    risManagerId: {
                        label: "Ответственный менеджер",
                        type: "selectSuggest",
                        required: true,
                        dataKey: "suggest.managers_suggest",
                        addClass: "full",
                        optionValue: "_id",
                        optionLabel: "fullName",
                        placeholder: "Выберите менеджера",
                        selectedItemKey: "_id",
                        appendTo: "self",
                        showClear: false,
                    },
                    name: {
                        label: "Название вендора",
                        type: "string",
                        required: true,
                        placeholder: "",
                        translitTo: "code",
                        duplicateToPath: ["name"],
                    },

                    vendorInfo: { type: "objectInputs", inputs: { site: { label: "Сайт вендора", type: "string", required: true, placeholder: "" } } },
                    categoriesIds: {
                        label: "Категории",
                        type: "multiSelect",
                        required: true,
                        apiUrl: "/promo/suggest_list?collection=categories&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc",
                        dataKey: "suggest.categories_suggest",
                        optionValue: "_id",
                        optionLabel: "title",
                        placeholder: "Выберите категории",
                        selectedItemKey: "_id",
                        appendTo: "self",
                    },
                    isPostbacksEnabled: {
                        label: "",
                        type: "switch",
                        switchLabel: "Postback",
                    },
                },
            },
            {
                blockName: "Логотип и иконки",
                inputs: {
                    logoList: {
                        label: "Desktop (280x87)",
                        type: "image",
                        required: true,
                        pathStorage: "logoList",
                        addClass: "imageupload unset",
                    },

                    squareLogo: { label: "Mobile (87х87)", type: "image", required: true, pathStorage: "squareLogo", addClass: "imageupload unset" },
                },
            },
            {
                blockName: "Email",
                inputs: {
                    logoEmail: { label: "Banner (287x87)", type: "image", required: true, pathStorage: "logoEmail", addClass: "imageupload" },
                },
            },

            {
                blockName: "Ставки",
                inputs: {
                    rateIds: {
                        type: "rates",
                        label: "Укажите ставки",
                        apiUrl: "/promo/suggest_list?collection=rates",
                    },
                },
            },

            {
                blockName: "Юридическая информация / ORD",
                inputs: {
                    vendorInfos: {
                        type: "ord",
                    },
                    vendorInfo: {
                        type: "objectInputs",
                        // required: true,
                        inputs: {
                            INN: {
                                required: true,
                            },
                        },
                    },
                },
            },
        ];

        return (
            <DefaultDetail
                apiUrl={secondParam === "add" ? "/promo/vendors" : `/promo/vendors/${secondParam}`}
                dataKey={secondParam}
                scopes={false}
                inputs={inputsNew}
                titleList={"title"}
                title="вендор"
                titleRight={"офферы"}
                urlUpload={"vendors"}
                page={"offers"}
                logging={true}
            />
        );
    }),
);

export default OfferDetail;
